export const BASE_CDN_URL = 'https://static.sw.cdn.siemens.com';
export const BASE_CDN_URL_UAT = 'https://static-uat.sw.cdn.siemens.com';
export const BASE_CDN_URL_DEV = 'https://static-dev.sw.cdn.siemens.com';
export const BASE_CDN_URL_STAGE = 'https://static-stage.sw.cdn.siemens.com';
// Base domain for the DISW Middleware (production).
export const BASE_API_CDN_URL = 'https://api.sw.siemens.com';
// Base domain for the DISW Middlware (development)
export const BASE_API_CDN_URL_DEV = 'https://api.dev.swi.siemens.com';
// Base domain for the DISW middleware (UAT environment)
export const BASE_API_CDN_URL_UAT = 'https://api.stage.swi.siemens.com';
// These URLs are for the DISW Middleware
export const MIDDLEWARE_API_URL = `${BASE_API_CDN_URL}/v1`;
export const MIDDLEWARE_API_URL_DEV = `${BASE_API_CDN_URL_DEV}/v1`;
export const MIDDLEWARE_API_URL_UAT = `${BASE_API_CDN_URL_UAT}/v1`;
export const MIDDLEWARE_API_URL_MOCK = 'https://8d5fe0eb-1bbc-4761-8c10-24e86337d7f9.mock.pstmn.io/dex-services-svc';
export const MIDDLEWARE_API_SUPPORT_CONTACTS_URL = `${MIDDLEWARE_API_URL}/livechat/phone-numbers/`;
export const MIDDLEWARE_API_SUPPORT_CONTACTS_URL_DEV = `${MIDDLEWARE_API_URL_DEV}/livechat/phone-numbers/`;
export const MIDDLEWARE_API_SUPPORT_CONTACTS_URL_UAT = `${MIDDLEWARE_API_URL_UAT}/livechat/phone-numbers/`;
export const WEBKEY_UPDATE_PROFILE_URL = 'https://identity.industrysoftware.automation.siemens.com/WebkeyLogin/DigitalExchangeUpdateProfile';
export const WEBKEY_UPDATE_PROFILE_URL_DEV = 'https://webtest.industrysoftware.automation.siemens.com/WebkeyLogin/DigitalExchangeUpdateProfile';
export const CDN_TRANSLATIONS_URL = `${BASE_CDN_URL}/translations`; // Note: Translations are all on this URL, env passed as part of path
export const IMAGES_CDN_URL = 'https://images.sw.cdn.siemens.com';
/**
 * Returns the appropriate DISW Middleware URL for the given environment.
 *
 * @param {string} env The environment to get the URL for. Can be one of "dev", "uat", "prod", or "mock".
 * @returns {string} The environment specific URL
 */
function _getMiddlewareUrl(env) {
    if (env === 'prod') {
        return MIDDLEWARE_API_URL;
    }
    else if (env === 'uat') {
        return MIDDLEWARE_API_URL_UAT;
    }
    else if (env === 'mock') {
        return MIDDLEWARE_API_URL_MOCK;
    }
    // default to DEV
    return MIDDLEWARE_API_URL_DEV;
}
/**
 * Get the DISW Middleware API URL for the specified environment.
 *
 * @param {string} env The environment to get the URL for. Can be one of "dev", "uat", or "prod".
 * @returns DISW Middleware API URL for the given environment.
 */
export function getMiddlewareAPIURL(env) {
    return _getMiddlewareUrl(env);
}
export function getTaxonomyAPIURL(env) {
    return _getMiddlewareUrl(env).replace('v1', 'taxonomy');
}
/**
 * Get the Breadcrumb API URL for the specified environment.
 *
 * @param {string} env The environment to get the URL for. Can be one of "dev", "uat", or "prod".
 * @returns The Breadcrumb API URL for the given environment.
 */
export function getBreadcrumbAPIURL(env) {
    const breadcrumbPath = '/api/breadcrumbs';
    if (env === 'prod') {
        return BASE_CDN_URL + breadcrumbPath;
    }
    else if (env === 'uat') {
        return BASE_CDN_URL_UAT + breadcrumbPath;
    }
    return BASE_CDN_URL_DEV + breadcrumbPath;
}
